import { defineComponent as _defineComponent } from 'vue'
import {
  BaseIcon,
  BaseText,
  ButtonPrimary,
  ButtonSecondary,
  Heading,
  InputPassword
} from '@warrenbrasil/nebraska-web';
import { Ref, computed, inject, onMounted, ref } from 'vue';
import {
  trackForgotPasswordEvent,
  trackPasswordEvent
} from '@/modules/authentication/helpers/track-signin-events';
import ForgotPasswordModal from '@/modules/authentication/views/SignIn/components/ForgotPasswordModal/ForgotPasswordModal.vue';
import { FadeTransition } from '@/modules/common/components/FadeTransition';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { SignInForm } from '@/modules/authentication/views/SignIn/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordSignIn',
  setup(__props) {

const form = inject('form') as Ref<SignInForm>;
const password = ref<string>('');
const handlePasswordSubmit = inject('handlePasswordSubmit') as (
  password: string
) => void;
const isLoading = inject('isLoading') as Ref<boolean>;
const isForgotPasswordModalOpen = ref<boolean>(false);
const changeToEmailStep = inject('changeToEmailStep') as () => void;

function toggleForgotPasswordModal() {
  !isForgotPasswordModalOpen && trackForgotPasswordEvent();
  isForgotPasswordModalOpen.value = !isForgotPasswordModalOpen.value;
}

const disableButton = computed(() => !password.value);

onMounted(() => {
  document.getElementById('password')?.focus();
});

return { __sfc: true,form, password, handlePasswordSubmit, isLoading, isForgotPasswordModalOpen, changeToEmailStep, toggleForgotPasswordModal, disableButton, BaseIcon, BaseText, ButtonPrimary, ButtonSecondary, Heading, InputPassword, trackPasswordEvent, ForgotPasswordModal, FadeTransition, NebraskaColors }
}

})